import { rem } from 'polished'
import styled from 'styled-components'

import { type IImporterProps } from '../Importer'

export const ImporterStyled = styled.div<Partial<IImporterProps>>`
  font-size: ${rem(16)};
  width: 100%;
`
